import { Injectable } from '@angular/core';

import { Action, State, StateContext } from '@ngxs/store';
import { Observable } from 'rxjs';

import { HttpApiService } from '../../../../core/http-api.service';
import {
  ReferralsPortalForgotPassword,
  ReferralsPortalResetPassword,
} from './forgat-password.actions';

@State({
  name: 'forgotPassword',
})
@Injectable()
export class ReferralsForgotPasswordRepo {
  constructor(public httpApiService: HttpApiService) {}

  @Action(ReferralsPortalForgotPassword)
  public referralsPortalForgotPassword(
    ctx: StateContext<any>,
    action: ReferralsPortalForgotPassword,
  ): Observable<void> {
    return this.httpApiService.post('/password/request_reset', null, {
      requestReset: action.payload,
    });
  }

  @Action(ReferralsPortalResetPassword)
  public referralsPortalResetPasword(
    ctx: StateContext<any>,
    action: ReferralsPortalResetPassword,
  ): Observable<void> {
    return this.httpApiService.post('/password/authorize_reset', null, {
      authorizeReset: action.payload,
    });
  }
}
